'use strict';

/** @module HigherOrderComponent
 */
var HigherOrderComponent = function(wrapper, component) {
	return wrapper(component);
};

module.exports = HigherOrderComponent;
